module.exports = __webpack_public_path__ + "img/currencyDetails1.d134509b.png";